var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { attrs: { title: _vm.title } }, [
    _c(
      "div",
      { staticClass: "flex flex-col w-full px-2 py-4 relative" },
      [
        _c("VueLoading", {
          attrs: { active: _vm.loading, "is-full-page": false },
          on: {
            "update:active": function($event) {
              _vm.loading = $event
            }
          }
        }),
        _vm._v(" "),
        _vm._t("graphic"),
        _vm._v(" "),
        _vm._t("analysis")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36c7e4c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c7e4c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/AICards/TimeSeriesCard/TimeSeries.vue
// module id = null
// module chunks = 